<template>
  <div class="wrapper px-4">
    <v-tabs color="primary primary-4" left>
      <v-tab>المستخدمين</v-tab>
      <v-tab>اضافة مستخدم</v-tab>
      <v-tab-item>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="بحث"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <ResizablePage>
            <template v-slot:table="tableProps">
              <v-data-table
                fixed-header
                :height="tableProps.tableHeight"
                :headers="headers"
                :items="users"
                :items-per-page="20"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon @click="editItem(item)"> mdi-pencil </v-icon>
                  <v-icon @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
              </v-data-table>
            </template>
          </ResizablePage>
        </v-card>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >هل انت متأكد من حذف الحساب؟</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >الغاء الحذف</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >نعم</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEdit" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">تعديل حساب المسؤول</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="البريد الالكتروني"
                        v-model="selectedUser.email"
                        :rules="emailRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="الاسم"
                        v-model="selectedUser.name"
                        :rules="nameRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="الرمز السري"
                        v-model="editForm.password"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeEditDialog">
                الغاء التعديل
              </v-btn>
              <v-btn color="blue darken-1" text @click="saveEditDialog">
                حفظ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <v-tab-item>
        <v-card width="500" height="550" class="mx-auto mt-16" flat>
          <v-card-text class="justify-center">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                solo
                light
                label="البريد الالكتروني"
                v-model="form.email"
                :rules="emailRules"
                required
              >
              </v-text-field>
              <v-text-field
                solo
                light
                type="text"
                label="الاسم"
                v-model="form.name"
                :rules="nameRules"
                required
              >
              </v-text-field>
              <v-text-field
                solo
                light
                type="password"
                label="الرمز السري"
                v-model="form.password"
                :rules="passwordRules"
                required
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              @click="CreateUser"
              rounded
              color="primary"
              dark
              large
              width="240"
              >اضافة</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark class="pa-4">
        <v-card-text>
          يرجى الانتظار...
          <v-progress-linear
            indeterminate
            color="accent"
            class="mt-4"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import ResizablePage from "@/components/resizable-page.vue";

export default {
  components: {
    ResizablePage,
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "البريد الالكتروني",
          align: "center",
          value: "email",
          class: "primary white--text ",
        },
        {
          text: "الاسم",
          align: "center",
          value: "name",
          class: "primary white--text ",
        },
        {
          text: "الاجرائات",
          align: "center",
          value: "actions",
          class: "primary white--text ",
        },
      ],
      users: [],
      editForm: {
        email: "",
        name: "",
        password: "",
      },
      form: {
        email: "",
        name: "",
        password: "",
      },
      valid: true,
      emailRules: [
        (v) => !!v || "البريد الالكتروني مطلوب",
        (v) =>
          /.+@.+\..+/.test(v) || "البريد الالكتروني يجب ان يكتب بصورة صحيحة",
      ],
      passwordRules: [(v) => !!v || "الرمز السري مطلوب"],
      nameRules: [(v) => !!v || "الاسم مطلوب"],
      dialogDelete: false,
      dialogEdit: false,
      selectedUser: "",
      loadingDialog: false,
    };
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    editItem(item) {
      this.dialogEdit = true;
      this.selectedUser = item;
    },
    closeEditDialog() {
      this.dialogEdit = false;
      this.selectedUser = "";
    },
    saveEditDialog() {
      if (this.$refs.form.validate()) {
        this.loadingDialog = true;
        const formData = new FormData();
        formData.append("email", this.selectedUser.email);
        formData.append("name", this.selectedUser.name);
        if (this.editForm.password != "") {
          formData.append("password", this.editForm.password);
        }
        axios
          .post(`auth/Users/${this.selectedUser.id}/update`, formData)
          .then((res) => {
            console.log(res);
            this.dialogEdit = false;
            this.loadingDialog = false;

            this.selectedUser = "";
            this.fetchUsers();
          })
          .catch(() => {
            this.loadingDialog = false;
          });
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.selectedUser = item;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.selectedUser = "";
    },
    deleteItemConfirm() {
      this.loadingDialog = true;

      axios
        .get(`auth/Users/${this.selectedUser.id}/delete`)
        .then((res) => {
          console.log(res);
          this.dialogDelete = false;
          this.selectedUser = "";
          this.fetchUsers();
          this.loadingDialog = false;
        })
        .catch(() => {
          this.loadingDialog = false;
        });
    },
    fetchUsers() {
      this.loadingDialog = true;

      const formData = new FormData();
      formData.append("filter", `[["type","=","User"]]`);
      formData.append("take", 100000000);
      formData.append("skip", 0);
      axios
        .post("Users/getList", formData)
        .then((res) => {
          this.users = res.data.items;
          console.log(res);
          this.loadingDialog = false;
        })
        .catch(() => {
          this.loadingDialog = false;
        });
    },
    CreateUser() {
      if (this.$refs.form.validate()) {
        this.loadingDialog = true;

        const formData = new FormData();
        formData.append("email", this.form.email);
        formData.append("name", this.form.name);
        formData.append("password", this.form.password);
        formData.append("type", "User");
        axios
          .post("auth/Users/create", formData)
          .then(() => {
            this.loadingDialog = false;
            this.fetchUsers();
          })
          .catch(() => {
            this.loadingDialog = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.wrapper {
  height: 100%;
  background: white;
}
</style>
